export default function() {
	return {
		id: undefined,
		orderNumber: undefined,
		accepted: false,
		additionalReferences: [],
		etd: date(),
		eta: date(),
		atd: date(),
		ata: date(),
		chargableWeight: 0,
		clerk: undefined,
		consignee: { ...address(), customerNumber: undefined },
		consigneeReference: undefined,
		consignor: { ...address(), customerNumber: undefined },
		customer: {
			...address(),
			customerNo: undefined
		},
		customersReference: undefined,
		deliveryParty: address(),
		despatchParty: address(),
		invoiceFreeText: undefined,
		loadingListFreeText: undefined,
		internalNotes: undefined,
		goodsListFreeText: undefined,
		transporterInstructions: undefined,
		freightLines: [
			{
				lineNo: 1,
				description: '',
				marks: '',
				netWeight: 0,
				grossWeight: 0,
				numberOfUnits: 0,
				chargableWeight: 0,
				height: 0,
				length: 0,
				loadingMeters: 0,
				numberOfPallets: 0,
				packageTypeCode: '',
				volume: 0,
				width: 0,
				palletPlacePrice: 0,
			}
		],
		goodsType: undefined,
		grossWeight: 0,
		loadingMeters: 0,
		mayGenerateReturnOrder: undefined,
		numberOfPackages: 0,
		numberOfPallets: 0,
		originalShipper: address(),
		packages: [],
		poReference: undefined,
		sendersReference: undefined,
		economicalStatus: undefined,
		status: undefined,
		volume: 0,
		waybillNumber: undefined,
		orderType: undefined,
		events: [],
		incotermsCode: undefined,
		incotermsPlace: undefined,
		documents: [],
		totalPrice: 0,
		currency: '',
		invoiceCurrencyPrice: 0,
		invoiceCurrency: '',
		manuallyPriced: false,
		priceLines: [],
		hasOpenedPackageLabels: false,
	};
}

function address() {
	return {
		id: undefined,
		name: undefined,
		street: undefined,
		country: undefined,
		postalCode: undefined,
		countryCode: undefined,
		postalPlace: undefined,
		latitude: undefined,
		longitude: undefined,
		contactName: undefined,
		contactPhone: undefined,
		contactEmail: undefined
	};
}


// function edi() {
// 	return { transmissions: [] };
// }

function date() {
	return {
		date: undefined,
		hasTime: false,
		timeZone: 'Europe/Oslo',
		epoch: undefined
	};
}
